import {toString} from 'es-toolkit/compat'

import * as optionApi from '../../../services/api/option'
import {
  factorToPercentageString,
  isMixedValue,
  percentageStringToFactor,
  toNumberValue,
  toPossiblyMixedValue,
  toStringValue,
} from '../../utils/form'

import {OptionWithLinkedProviderInfos, Provider} from '../../../types'

import {MixedFormData, SingleFormData} from './form'

// FormData Production Times to optionApi Production Times

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formDataTransforms: Record<string, (value: any) => any> = {
  name: name => name,
  type: type => type,
  basePrice: toNumberValue,
  productionTimeFastTotal: toNumberValue,
  productionTimeSlowTotal: toNumberValue,
  factor: percentageStringToFactor,
}

export const formDataToProductionTimeOptionRequest = (
  formData: SingleFormData,
  provider: Provider
): optionApi.OptionRequest => ({
  name: formDataTransforms.name(formData.name),
  type: formDataTransforms.type(formData.type),
  factor: formDataTransforms.factor(formData.factor),
  basePrice: formDataTransforms.basePrice(formData.basePrice),
  productionTimeFastTotal: formDataTransforms.productionTimeFastTotal(
    formData.productionTimeFastTotal
  ),
  productionTimeSlowTotal: formDataTransforms.productionTimeSlowTotal(
    formData.productionTimeSlowTotal
  ),
  productionTimeFastOffset: null,
  productionTimeSlowOffset: null,
  materialId: null,
  provider: provider.id,
})

export const formDataToPartialProductionTimeOptionRequest = (formData: Partial<SingleFormData>) => {
  const productionTimeOptionRequest: Partial<optionApi.OptionRequest> = {}

  Object.keys(formData).forEach(key => {
    const value = formData[key as keyof SingleFormData]
    const productionTimeOptionRequestTransform = formDataTransforms[key]

    if (!isMixedValue(value) && productionTimeOptionRequestTransform) {
      productionTimeOptionRequest[key as keyof optionApi.OptionRequest] =
        productionTimeOptionRequestTransform(value)
    }
  })

  return productionTimeOptionRequest
}

// optionApi Production Times to FormData Production Times

export const productionTimeOptionsToFormData = (
  productionTimeOptions: OptionWithLinkedProviderInfos[]
): MixedFormData => ({
  name: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.name),
    toString
  ),
  type: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.type),
    toString
  ),
  factor: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.factor),
    factorToPercentageString
  ),
  basePrice: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.basePrice),
    toStringValue
  ),
  productionTimeFastTotal: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.productionTimeFastTotal),
    toStringValue
  ),
  productionTimeSlowTotal: toPossiblyMixedValue(
    productionTimeOptions.map(pricing => pricing.productionTimeSlowTotal),
    toStringValue
  ),
})
